/**
 * Created by Sergey Shoshin on 2017-04-19.
 */
export interface ICanadapostAddress {
    Line1: string;
    Line2: string;
    Line3: string;
    City: string;
    PostalCode: string;
    Province: string;
    ProvinceCode: string;
    ProvinceName: string;
    Street: string;
    BuildingNumber: string;
    Company: string;
    CountryIsoNumber: number;
    CountryName: string;
    CountryIso2: string;
    CountryIso3: string;
    Label: string;
    Id: string;
    Language: string;
}

export class CandapostAutocompleteOptions {
    constructor(
        public key: string,
        public setCountryByIP = false,
        public supressAutocomplete = true,
        public bar: CandapostAutocompleteBarOptions = new CandapostAutocompleteBarOptions(),
        public countries: any = { defaultCode: 'CA' }
    ) {

    }
}

export class CandapostAutocompleteBarOptions {
    constructor(
        public showCountry = false,
        public showLogo = false,
        public logoLink = false,
        public visible = false
    ) {

    }
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/canadapost.models.ts